import http from "./httpService";

export function userAuth() {
  return http.get("/auth");
}